import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'openai-terms-modal',
    templateUrl: './openai-terms-modal.component.html',
    styleUrls: ['./openai-terms-modal.component.css'],
    standalone: false
})
export class OpenaiTermsModalComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
